import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@fluentui/react-components";
export default function RetryAction({ children = "Retry" }) {
    return (_jsx(Button, { onClick: () => {
            window.location.reload();
        }, children: children }));
}
